export { default } from './request-equipment-service-notification-banner';
